import './src/polyfills.ts';
import './node_modules/stream-browserify/index.js';